module.exports = __webpack_public_path__ + "img/consent_received_icon.ec893142.svg";